export default {
  page: 1,
  pageSize: 15,
  pageCount: 1,
  query: '',
  tags: [],
  creators: [],
  selectSortValue: { id: 0, name: 'Sort by most recent' },
  selectCreatorValue: [],
  selectValue: [],
  charts: []
};
